import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, Clock, User } from "@phosphor-icons/react";
import { api, adminHeaders } from "@/lib/api";

export const ReminderSettings = ({ onClose }) => {
    const [items, setItems] = useState(null);

    useEffect(() => {
        api.get("/admin/wa/reminder-previews", { headers: adminHeaders() })
            .then((res) => setItems(res.data))
            .catch(() => toast.error("Gagal memuat pratinjau pengingat"));
    }, []);

    return (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="reminder-settings-overlay">
            <div className="bg-white border border-border w-full max-w-md max-h-[90vh] overflow-y-auto p-6 space-y-4" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-start justify-between">
                    <div>
                        <p className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">Pengaturan</p>
                        <h2 className="font-serif text-2xl tracking-tight font-medium mt-1">Pengingat & Notifikasi</h2>
                    </div>
                    <button data-testid="reminder-settings-close" onClick={onClose} className="text-muted-foreground hover:text-foreground transition-colors" title="Tutup">
                        <X size={20} weight="light" />
                    </button>
                </div>
                <p className="text-xs text-muted-foreground">
                    Semua pesan otomatis yang dikirim sistem lewat WhatsApp. Contoh pesan di-generate langsung dari data saat ini — hanya pratinjau, tidak dikirim ke WA.
                </p>
                {!items ? (
                    <p className="text-xs text-muted-foreground">Memuat pratinjau...</p>
                ) : (
                    items.map((it) => (
                        <div key={it.key} className="border border-border p-3.5 space-y-2" data-testid={`reminder-${it.key}`}>
                            <p className="text-sm font-medium">{it.title}</p>
                            <p className="text-xs text-muted-foreground flex items-center gap-1.5">
                                <Clock size={13} weight="light" className="shrink-0" /> {it.schedule}
                            </p>
                            <p className="text-xs text-muted-foreground flex items-center gap-1.5">
                                <User size={13} weight="light" className="shrink-0" />
                                {it.to.map((t) => `${t.name}${t.phone !== "—" ? ` (${t.phone})` : " (nomor belum diisi)"}`).join(", ")}
                            </p>
                            <div className="bg-secondary border border-border px-3 py-2.5 text-xs whitespace-pre-wrap break-words font-mono" data-testid={`reminder-sample-${it.key}`}>
                                {it.sample}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};
